import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getHomeCaroselSliceContent = createAsyncThunk('/homeCarosels/content', async () => {
	const response = await axios.post(`${API_URL}/getHomeCarosels`);
    console.log(response.data);
	return response;
})

export const homeCaroselSlice = createSlice({
    name: 'homeCarosels',
    initialState: {
        isLoading: false,
        homeCarosels : []
    },
    reducers: {
    },
    extraReducers: {
		[getHomeCaroselSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getHomeCaroselSliceContent.fulfilled]: (state, action) => {
			state.homeCarosels = action.payload.data
			state.isLoading = false
		},
		[getHomeCaroselSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default homeCaroselSlice.reducer